export function copyToClipboard(text: string): boolean {
  const span = document.createElement("span");
  const selection = document.getSelection();

  try {
    span.textContent = text;
    document.body.append(span);

    const range = document.createRange();
    range.selectNode(span);
    selection?.removeAllRanges();
    selection?.addRange(range);

    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    selection?.removeAllRanges();
    if (document.body.contains(span)) {
      span.remove();
    }
  }
}
